// extracted by mini-css-extract-plugin
export var container = "styles-module--container--sKLWD";
export var imgStairs = "styles-module--imgStairs--IbBR2";
export var featureText = "styles-module--featureText--I4jR7";
export var containerText = "styles-module--containerText--MO8k6";